import styled from 'styled-components';
import CommonBtn from '../../atoms/Buttons/CommonBtn';

export const Button = styled(CommonBtn)`
  width: 100%;
  margin-bottom: 10px;
`;
